import * as z$1 from "zod/v4";
//#region src/schemas/runtime/agent-controller-session.ts
const agentControllerSessionTitleSchema = z$1.string().trim().min(1).max(120);
//#endregion
export { agentControllerSessionTitleSchema };

//# sourceMappingURL=agent-controller-session.js.map